export default () => ({
  showed: null,
  toggle(idx) {
    this.showed = idx === this.showed ? null : idx;
  },
});
